module.exports = __webpack_public_path__ + "static/img/why-2.799f049f.jpg";